import { 
  getText, 
  appendText 
} from '../../../assets/js/text-renderer';

import './features-compute.scss';
import 'bootstrap/js/dist/collapse';

export const loadText = async(mainFeaturesEl, ctaButtons) => {
  const data = await getText('platform/intelek-compute/intelek-compute-features');
  const content = data.stories[0].content;

  setHeroContent(content, ctaButtons, mainFeaturesEl);
  setFeaturedContent(content, mainFeaturesEl);
  setPipesContent(content, mainFeaturesEl);
  setGovernanceContent(content, mainFeaturesEl);
  setMonitoringContent(content, mainFeaturesEl);
}

function setHeroContent(content, ctaButtons, mainFeaturesEl) {
  appendText(content.hero_title, 'hero-title', mainFeaturesEl);
  appendText(ctaButtons.start_trial_btn, 'hero-cta-trial-button', mainFeaturesEl);
  appendText(ctaButtons.book_demo_btn, 'hero-cta-demo-button', mainFeaturesEl);
  appendText(content.summary, 'summary', mainFeaturesEl);
}

function setFeaturedContent(content, mainFeaturesEl) {
  appendText(content.featured[0].text, 'featured-option-0', mainFeaturesEl);
  appendText(content.featured[1].text, 'featured-option-1', mainFeaturesEl);
  appendText(content.featured[2].text, 'featured-option-2', mainFeaturesEl);
  appendText(content.featured_headline, 'featured-headline', mainFeaturesEl);
}

function setPipesContent(content, mainFeaturesEl) {
  appendText(content.pipes_title, 'pipes-title', mainFeaturesEl);
  appendText(content.pipes_features[0].title, 'pipes-feat-0-title', mainFeaturesEl);
  appendText(content.pipes_features[0].description, 'pipes-feat-0-desc', mainFeaturesEl);
  appendText(content.pipes_features[1].title, 'pipes-feat-1-title', mainFeaturesEl);
  appendText(content.pipes_features[1].description, 'pipes-feat-1-desc', mainFeaturesEl);
  appendText(content.pipes_features[2].title, 'pipes-feat-2-title', mainFeaturesEl);
  appendText(content.pipes_features[2].description, 'pipes-feat-2-desc', mainFeaturesEl);
  appendText(content.pipes_features[3].title, 'pipes-feat-3-title', mainFeaturesEl);
  appendText(content.pipes_features[3].description, 'pipes-feat-3-desc', mainFeaturesEl);
}

function setGovernanceContent(content, mainFeaturesEl) {
  appendText(content.gobernance_featured_title, 'gobernance-featured-title', mainFeaturesEl);
  appendText(content.gobernance_featured_options[0].text, 'gobernance-feat-option-0', mainFeaturesEl);
  appendText(content.gobernance_featured_options[1].text, 'gobernance-feat-option-1', mainFeaturesEl);
  appendText(content.gobernance_featured_options[2].text, 'gobernance-feat-option-2', mainFeaturesEl);
}

function setMonitoringContent(content, mainFeaturesEl) {
  appendText(content.monitoring, 'monitoring', mainFeaturesEl);
}